import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./404.css";

export default function PageNotFound() {
  const navigate = useNavigate();

  return (
    <motion.div
      className="notfound-page"
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -14 }}
      transition={{ duration: 0.25 }}
    >
      <div className="notfound-container">
        <div className="notfound-code">404</div>
        <h1 className="notfound-title">Page Not Found</h1>
        <p className="notfound-desc">
          This page doesnt exist, please go back to the homepage
        </p>
        <div className="notfound-actions">
          <button className="btn-primary" onClick={() => navigate("/")}>
            Go Home
          </button>
          <button className="btn-outline" onClick={() => window.history.back()}>
            Go Back
          </button>
        </div>
      </div>
    </motion.div>
  );
}
